import { Component, ViewChild, ElementRef, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-image-zoom',
  templateUrl: './image-zoom.component.html',
  styleUrls: ['./image-zoom.component.less']
})
export class ImageZoomComponent implements OnInit {
  
  @ViewChild('tile') 
  photoDiv: ElementRef;
  @ViewChild('photo') 
  image: ElementRef;
  
  @Input('data-scale') 
  scale: number;
  @Input('data-src') 
  src: string;

  constructor() { }
  
  ngOnInit() {
    let elem = this.photoDiv.nativeElement;
    this.image.nativeElement.style['background-image'] = 'url('+ this.src + ')';
    elem.addEventListener('mouseover', (event) => {
      this.image.nativeElement.style.transform = 'scale('+ this.scale +')';
    });
    elem.addEventListener('mouseout', (event) => {
      this.image.nativeElement.style.transform = 'scale(1)';
    });
    elem.addEventListener('mousedown', (event) => {
      this.image.nativeElement.style.transform = 'scale(1)';
    });
    elem.addEventListener('mousemove', (event) => {
      this.image.nativeElement.style.transform = 'scale('+ this.scale +')';
      let offset = this.getOffset();
      let value = ((event.pageX - offset.left) / elem.clientWidth) * 100 + '% ' + 
                  ((event.pageY - offset.top) / elem.clientHeight) * 100 + '%';
      this.image.nativeElement.style['transform-origin'] = value;
    });    
  }

  private getOffset(): any {
    var de = document.documentElement;
    var box = this.photoDiv.nativeElement.getBoundingClientRect();
    var top = box.top + window.pageYOffset - de.clientTop;
    var left = box.left + window.pageXOffset - de.clientLeft;
    return { top: top, left: left };
  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/image-zoom/image-zoom.component.ts